module.exports = __webpack_public_path__ + "static/media/recruit_780_business.b12c5685.png";